$(document).ready(function () {
	$(document).on('click', '.btn-order-duplicate', function () {
		let url = $(this).attr('href');

		if (confirm('Вы действительно хотите повторить заказ? Все блюда будут добавлены в корзину.')) {
			sendDynamicForm(url, {
				_token: App.csrf
			});
		}

		return false;
	});
});
